<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { LockKeyhole, Truck } from "lucide-vue-next";
import { adminLogin } from "@/lib/session";

const route=useRoute();const router=useRouter();const password=ref("");const loading=ref(false);const error=ref("");
async function login(){loading.value=true;error.value="";try{await adminLogin(password.value);await router.replace(String(route.query.redirect||"/admin"))}catch(cause){error.value=cause instanceof Error?cause.message:"登录失败"}finally{loading.value=false}}
</script>

<template>
  <section class="admin-login">
    <form class="admin-login-card" @submit.prevent="login">
      <div class="brand-mark" style="width:56px;height:56px;border-radius:16px"><Truck :size="29" /></div>
      <h1 style="margin:0 0 6px">HaulGauge 管理后台</h1><p class="muted" style="margin:0 0 25px">任务、审核、司机与数据导出</p>
      <label class="field"><span>管理员密码</span><div class="password-field"><LockKeyhole :size="18" /><input v-model="password" type="password" autocomplete="current-password" placeholder="输入部署时设置的管理密码" /></div></label>
      <p v-if="error" class="error-banner">{{ error }}</p>
      <button class="btn btn-primary btn-block" :disabled="loading||!password" type="submit">{{ loading?"正在验证…":"登录管理后台" }}</button>
      <a href="/" class="small muted" style="display:block;margin-top:18px;text-align:center">返回司机端</a>
    </form>
  </section>
</template>

<style scoped>
.password-field{height:46px;padding:0 12px;display:flex;align-items:center;gap:9px;border:1px solid #dce3ec;border-radius:10px;background:#f8fafc}.password-field input{width:100%;border:0;outline:0;background:transparent}.error-banner{margin:12px 0}
</style>
